<template>
  <div class="non-quote">
    <div class="d-flex justify-content-center spinner" v-if="!thereIsData">
      <Loading size="200" />
    </div>
    <div v-else>
      <h5><b>SUBJECT: </b>{{ item.subject }}</h5>
      <div class="non-quote__options">
        <b-overlay
          :show="charging"
          rounded
          opacity="0.6"
          spinner-small
          class="d-inline-block"
        >
          <b-button
            aria-label="Click here to send to queue"
            @click="changeStatus"
            ref="button-send-queue"
            class="non-quote__options__button mr-2"
            size="sm"
            >Send to Queue
          </b-button>
        </b-overlay>
        <MessageHistory class="non-quote__top-buttons history-button" />
      </div>
      <hr />
      <div class="non-quote__message">
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import MessageHistory from "../InfoEmail/shared/MessageHistory";

export default {
  name: "NonQuote",
  components: {
    Loading,
    MessageHistory
  },
  data() {
    return {
      item: null,
      thereIsData: false,
      user: null,
      nameDepartment: null,
      charging: false
    };
  },
  async created() {
    let messageId = this.$route.params.id;
    let response = await this.$store.dispatch(
      "quotes/quote/getMessage",
      messageId
    );
    this.item = response.data;
    this.thereIsData = true;
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    if (this.user[0].department.name == "ltl") {
      this.nameDepartment = "LTL";
    } else if (this.user[0].department.name == "ftl") {
      this.nameDepartment = "FTL";
    }
  },
  methods: {
    async changeStatus() {
      this.charging = true;
      let info = {};
      info.quotes = [];
      info.quotes.push(this.item.id);
      let response = await this.$store.dispatch("quotes/changeStatus", info);
      this.charging = false;
      if (response.status == 200) {
        this.$router.push({ name: "Emails", params: { pathName: "queue" } });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.non-quote {
  min-height: $view-height;
  margin: 50px 120px;
  &__options {
    margin: 30px 0px;
    &__button {
      @include primary-button;
    }
  }
  &__message {
    text-align: justify;
    text-justify: inter-word;
  }
  &__top-buttons {
    display: inline-block;
  }
}

.spinner {
  @include spinner;
}

@media (max-width: 427px) {
  .history-button {
    margin-top: 8px;
  }
}
</style>
